import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class SideNavService {
    private sidenavOpenSource = new BehaviorSubject(false);
    sidenavOpen$ = this.sidenavOpenSource.asObservable();

    constructor() {}

    toggle(): void {
        this.sidenavOpenSource.next(!this.sidenavOpenSource.getValue());
    }

    open(): void {
        this.sidenavOpenSource.next(true);
    }

    close(): void {
        this.sidenavOpenSource.next(false);
    }
}
